export const filterAuthFromRedux = ({ auth }) => {
  const { authorities, language, role } = auth

  return {
    authorities,
    language,
    role,
  }
}

export const filterStoreInfoFromRedux = ({ storeInfo }) => {
  const { currentRepresentative, currentStore, debitDisabled } = storeInfo

  return { currentRepresentative, currentStore, debitDisabled }
}

export const filterPayApplyFromRedux = ({ payApply }) => {
  const { current } = payApply || {}
  const { id: paymentId, selectedPaymentMethod } = current || {}
  const { id: paymentMethodId } = selectedPaymentMethod || {}

  return {
    current: {
      paymentId,
      paymentMethodId,
    },
  }
}
